import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface RepeatInfoState {
  reloadType: string;
  reloadTitle: string;
  reloadMinTitle: string;
  reloadTime: number;
}

const LOCALKEY = localKeyInfo.repeatInfo;
const localVoiceInfo = LocalStore.getValue<RepeatInfoState>(LOCALKEY) || {};

export const repeatInfo: RepeatInfoState = {
  reloadType: '',
  reloadTitle: '',
  reloadMinTitle: '',
  reloadTime: 0,
  ...localVoiceInfo
};

export const setRepeatInfo: (payload: RepeatInfoState) => IAction<RepeatInfoState> = (payload: RepeatInfoState) => ({
  type: 'setRepeatInfo',
  payload
});

const repeatInfoReducer: Reducer<RepeatInfoState, IAction<any>> = (state = repeatInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setRepeatInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default repeatInfoReducer;
